import React, { useRef, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import Player from "../lordicon/LazyPlayer";
import styles from './Button.module.css';

const PinkScrollButton = ({ text, icon, to, onClick }) => {
    const playerRef1 = useRef(null);
    const playerRef2 = useRef(null);

    useEffect(() => {
      playerRef1?.current?.playFromBeginning();
      playerRef2?.current?.playFromBeginning();
    }, []);

    const handleComplete = (ref) => {
      setTimeout(() => {
        ref?.current?.playFromBeginning();
      }, 1000);
    };

    const inner = (
      <>
        <div className={styles.rightIcon}>
          <Player
            icon={icon}
            size="100%"
            onReady={() => playerRef2?.current?.playFromBeginning()}
            onComplete={() => handleComplete(playerRef2)}
            ref={playerRef2}
          />
        </div>
        <span className={styles.text}>{text}</span>
      </>
    );

    // בלי יעד גלילה הכפתור מפעיל פעולה משלו, ולכן הוא נטען כ-button אמיתי
    // כדי שיהיה נגיש למקלדת ולקוראי מסך.
    if (!to) {
      return (
        <button type="button" onClick={onClick} className={styles.button}>
          {inner}
        </button>
      );
    }

    return (
      <ScrollLink to={to} smooth={true} duration={1500} onClick={onClick} className={styles.button}>
        {inner}
      </ScrollLink>
    );
};

export default PinkScrollButton;